module.exports = __webpack_public_path__ + "img/4800.8fd7b111.jpg";